import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
export default function () {
    function onClick1(isOpened, items, selectedItemKey, e) {
        this.handleDropdownButton(e);
    }
    function onBlur2(isOpened, items, selectedItemKey) {
        this.handleOnBlur();
    }
    function onClick3(isOpened, items, selectedItemKey, item, itemIndex, e) {
        this.handleItemClick(e, item);
    }
    function repeatItem4(isOpened, items, selectedItemKey, item, itemIndex) {
        return React.createElement('div', {
            'className': classNames('ui-select-dropdown__option', { 'ui-select-dropdown__option--selected': item === this.state.selectedItem }),
            'onClick': onClick3.bind(this, isOpened, items, selectedItemKey, item, itemIndex),
            'key': itemIndex
        }, React.createElement('span', { 'className': classNames('ui-select--sortByMode-icon', 'ui-select--sortBymode-icon--' + item) }, '\r\n          ', item !== this.state.selectedItem ? 'Switch to ' : '', ' ', item == 'All' ? 'All Features' : item, '\r\n        '));
    }
    function scopeIsOpenedItemsSelectedItemKey5() {
        var isOpened = this.state.isOpened;
        var items = this.props.items;
        var selectedItemKey = this.state.selectedItemKey;
        return React.createElement('div', {
            'className': classNames('ui-select', {
                'ui-select--large': this.state.large,
                'ui-select--wide': this.state.large
            }),
            'style': this.props.style
        }, React.createElement('div', {
            'className': classNames('ui-select-container', { 'ui-select-container--opened': isOpened }),
            'onClick': onClick1.bind(this, isOpened, items, selectedItemKey)
        }, React.createElement('span', { 'className': classNames('ui-select-text', 'ui-select-text--sortByMode-icon--' + this.state.selectedItem) }, 'Sort By'), isOpened ? React.createElement.apply(this, [
            'div',
            {
                'className': classNames('ui-select-dropdown', { 'ui-select-dropdown--opened': isOpened }),
                'ref': node => this.state.dropDownRef = node,
                'tabIndex': '1',
                'onBlur': onBlur2.bind(this, isOpened, items, selectedItemKey),
                'key': '642'
            },
            React.createElement('span', { 'className': classNames('ui-select-text', 'ui-select-text--sortByMode-icon--' + this.state.selectedItem) }, 'Sort By'),
            _.map(items, repeatItem4.bind(this, isOpened, items, selectedItemKey)),
            React.createElement('div', { 'className': 'ui-select-dropdown__option ui-select-dropdown__option--footer' })
        ]) : null));
    }
    return scopeIsOpenedItemsSelectedItemKey5.apply(this, []);
}